import { string } from 'yup';

const rule = {
	name: 'regex',
	method ({ message, element } = { message: 'Invalid input' }) {

		return this.test('regex', message, function (value) {

			const re = new RegExp(element);
			const { createError } = this;
			return re.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
